import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gro99lye: FaireBrandEntity = {
  token: "b_gro99lye",
  type: "brand",
  name: "Sweet Wink",
  avatarUrl:
    "https://cdn.faire.com/fastly/59e1f0961ad6885f4303e6da17454837aa8cd6570ffe2a73c5b4c03946915681.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/12b43be0cef7d6803ef175cf346667d7a5b5c0eaf63e1629f60c89e7b8c455e9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/59e1f0961ad6885f4303e6da17454837aa8cd6570ffe2a73c5b4c03946915681.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/12b43be0cef7d6803ef175cf346667d7a5b5c0eaf63e1629f60c89e7b8c455e9.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 177,
  isTopShop: true,
  isInsider: true,
  description:
    "Sweet Wink is a lifestyle children's special occasion lifestyle brand designed by a mother/daughter duo in New York City. We aim to make every day a party with our colorful and celebratory collection of graphic tees, tutus, and hair accessories. \n\nWe design head to toe looks that celebrate life's most special occasions from newborn announcements, to birthday parties, and everyone's favorite holidays.\n\nWhy do we do it? We believe every day is a party worth celebrating! So throw on your tutu and grab your favorite glitter bow because it's time to get this party started! ",
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:30:17.676Z",
    importedBy: "entity-db-cli",
  },
};
